import { render, staticRenderFns } from "./Etapa5.vue?vue&type=template&id=455ea7f6&scoped=true"
import script from "./Etapa5.vue?vue&type=script&lang=js"
export * from "./Etapa5.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=455ea7f6&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa5.vue?vue&type=style&index=1&id=455ea7f6&prod&scoped=true&lang=css"
import style2 from "./Etapa5.vue?vue&type=style&index=2&id=455ea7f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ea7f6",
  null
  
)

export default component.exports